import { useUser } from 'components/providers/UserProvider'
import { useTranslation } from 'react-i18next'
import { CardmarketConnect } from '../cardmarket'
import { CardtraderConnect } from '../cardtrader/CardtraderConnect'
import { ShopifyConnect } from '../shopify/ShopifyConnect'
import { SalesChannelsConnector } from './SalesChannelConnector'

export const SalesChannelsPresenter = (): JSX.Element => {
  const { t } = useTranslation()
  const { user } = useUser()

  const showShopifyButton = () => {
    return (
      <div className="mt-5">
        <h5 className="pb-3">{t('common.channels.shopify')}</h5>
        {user.featureFlags && user.featureFlags.shopify ? (
          <ShopifyConnect noHelperText />
        ) : (
          <SalesChannelsConnector
            type="Shopify"
            title={t('connectShopify.contactUs')}
            active={false}
            buttons={[]}
          />
        )}
      </div>
    )
  }

  const showCardTraderButton = () => {
    return (
      <div className="mt-5">
        <h5 className="pb-3">{t('common.channels.cardtrader')}</h5>
        <CardtraderConnect startAlignment />
      </div>
    )
  }

  return (
    <div id="sales-channels" className="p-3">
      <div className="mt-3">
        <h5 className="pb-3">{t('common.channels.cardmarket')}</h5>
        <CardmarketConnect noHelperText />
      </div>
      {showShopifyButton()}
      {showCardTraderButton()}
      <div className="mt-5">
        <h5 className="pb-3">Ebay (coming soon)</h5>
        <SalesChannelsConnector
          type="Ebay"
          title="Connect Ebay"
          icon="fa-brands fa-ebay"
          active={false}
          buttons={[]}
        />
      </div>
      <div className="mt-5">
        <h5 className="pb-3">API (coming soon)</h5>
        <SalesChannelsConnector
          type="API"
          title="API"
          icon="fa-regular fa-code"
          active={false}
          buttons={[]}
        />
      </div>
    </div>
  )
}
